import { render, staticRenderFns } from "./LanguageField.vue?vue&type=template&id=73a8805a"
import script from "./LanguageField.vue?vue&type=script&lang=js"
export * from "./LanguageField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports